import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "l_bts"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 1,
  class: "l-bt-flex"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
import { ElMessage } from 'element-plus';
import { ref, reactive, getCurrentInstance, watch } from 'vue';
import { useRouter } from 'vue-router';
/* 数据层 */

export default {
  __name: 'lcButtons',
  props: ['type', 'bts', 'planStratTime', 'ids', 'userId', 'reviewerUserId', 'msg', 'task', 'projectName'],
  emits: ["btsEmit", 'getPageInfo'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    let router = useRouter();
    const {
      proxy
    } = getCurrentInstance();
    const dialogVisible = ref(false);
    const pQshow = ref(false);
    const zPshow = ref(false);
    const rybgshow = ref(false);
    const bhshow = ref(false);
    function handelClose(value) {
      dialogVisible.value = false;
      pQshow.value = false;
      zPshow.value = false;
      rybgshow.value = false;
      bhshow.value = false;
    }
    const pop = __props;
    let theids = ref('');
    watch(() => pop.ids, (newValue, oldValue) => {
      theids.value = newValue;
    });
    const btsArry = reactive([{
      name: '保存',
      type: 'defalut',
      methodName: 'saveBt'
    }, {
      name: '操作状态',
      defalutName: '操作状态',
      type: 'dropdown',
      dropdownlist: [{
        name: '排期',
        methodName: 'paiQi'
      }, {
        name: '转派',
        methodName: 'zhuangPai'
      }, {
        name: '暂停',
        methodName: 'zhanTing'
      }]
    }, {
      name: '提交',
      defalutName: '提交',
      methodName: 'submitBt',
      type: 'dropdown',
      dropdownlist: [{
        name: '提交',
        methodName: 'submitBt'
      }, {
        name: '撤销',
        methodName: 'revoke'
      }]
    }, {
      name: '审核',
      defalutName: '审核',
      type: 'dropdown',
      methodName: 'passBt',
      dropdownlist: [{
        name: '通过',
        methodName: 'passBt'
      }, {
        name: '驳回',
        methodName: 'rejectBt'
      }]
    }, {
      name: '项目资料',
      type: 'defalut',
      methodName: 'projectInfobt'
    }, {
      name: '修改审核人',
      type: 'defalut',
      methodName: 'pepoleChange'
    }, {
      name: '日志',
      type: 'defalut',
      methodName: 'log'
    }]);
    const btsArry2 = reactive([{
      name: '操作状态',
      defalutName: '操作状态',
      type: 'dropdown',
      dropdownlist: [{
        name: '排期',
        methodName: 'pq'
      }, {
        name: '转派',
        methodName: 'zp'
      }, {
        name: '暂停',
        methodName: 'zt'
      }]
    }, {
      name: '提交',
      defalutName: '提交',
      type: 'dropdown',
      dropdownlist: [{
        name: '提交',
        methodName: 'tj'
      }, {
        name: '撤销',
        methodName: 'cx'
      }]
    }, {
      name: '通过',
      type: 'defalut',
      methodName: 'pass'
    }, {
      name: '修改审核人',
      type: 'defalut',
      methodName: 'rybg'
    }]);
    const emit = __emit;
    function dropbtn(methodName, btname) {
      if (btname == '提交' || btname == '审核') {
        btsEmit(methodName);
      }
      // if (btname == '审核') {
      //   thepass()
      // }
      // if (btname == '提交') {
      //   thesubmit('submitBt')
      // }
      console.log(btname);
    }
    function btsEmit(value) {
      if (value == 'projectInfobt') {
        // 项目资料
        dialogVisible.value = true;
      }
      if (value == 'paiQi') {
        // 排期
        pQshow.value = true;
      }
      if (value == 'zhuangPai') {
        //转派
        zPshow.value = true;
      }
      if (value == 'pepoleChange') {
        // 人员变更
        rybgshow.value = true;
      }
      if (value == 'zhanTing') {
        //暂停
        if (theids) {
          proxy.$http.showLoading(false).get('project/task/ch_status', {
            ids: theids.value,
            type: 20
          }).then(res => {
            if (res.errno == 200) {
              ElMessage({
                type: 'success',
                message: '操作成功'
              });
              emit("getPageInfo");
            } else {
              ElMessage({
                type: 'error',
                message: res.errmsg
              });
            }
          });
        }
      }
      if (value == 'passBt') {
        // thepass()
      }
      if (value == 'rejectBt') {
        // 驳回
        bhshow.value = true;
      }
      if (value == 'revoke') {
        // 驳回 value == 'submitBt' 10是提交，0是撤回
        thesubmit(value);
      }
      // 日志
      if (value == 'log') {
        console.log('日志', theids, theids.value);
        router.push({
          path: '/lcProject/log/prlog',
          query: {
            task_id: theids.value,
            projectName: pop.projectName
          }
        });
      }
      emit("btsEmit", value);
    }
    function thepass() {
      // 通过
      if (theids) {
        proxy.$http.showLoading(false).get('project/task/pass', {
          ids: theids.value
        }).then(res => {
          if (res.errno == 200) {
            ElMessage({
              type: 'success',
              message: '操作成功'
            });
            emit("getPageInfo");
          } else {
            ElMessage({
              type: 'error',
              message: res.errmsg
            });
          }
        });
      }
    }
    function thesubmit(value) {
      if (theids.value) {
        proxy.$http.showLoading(false).get('project/task/submit', {
          ids: theids.value,
          examine_status: value == 'submitBt' ? 10 : 0
        }).then(res => {
          if (res.errno == 200) {
            ElMessage({
              type: 'success',
              message: '操作成功'
            });
            emit("getPageInfo");
          } else {
            ElMessage({
              type: 'error',
              message: res.errmsg
            });
          }
        });
      } else {
        ElMessage({
          type: 'error',
          message: '请选择，在操作'
        });
      }
    }
    /* 曝露方法或者属性值给父组件或者其他子组件用 */
    __expose({
      thepass,
      thesubmit
    });
    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_lcDailogzl = _resolveComponent("lcDailogzl");
      const _component_lcDailogPQ = _resolveComponent("lcDailogPQ");
      const _component_lcDailogZP = _resolveComponent("lcDailogZP");
      const _component_lcDailogrybg = _resolveComponent("lcDailogrybg");
      const _component_lcDailogrybh = _resolveComponent("lcDailogrybh");
      return _openBlock(), _createElementBlock(_Fragment, null, [__props.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.bts, (it, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "l-button",
          key: index,
          onClick: $event => btsEmit(it.methodName)
        }, _toDisplayString(it.name), 9, _hoisted_2);
      }), 128)), _renderSlot(_ctx.$slots, "check")])) : _createCommentVNode("", true), __props.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.task == 'task' ? btsArry2 : btsArry, (it, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: it.name
        }, [it.type == 'defalut' ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "l-button",
          onClick: $event => btsEmit(it.methodName)
        }, _toDisplayString(it.name), 9, _hoisted_4)) : _createCommentVNode("", true), it.type == 'plain' ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "l-button2",
          onClick: $event => btsEmit(it.methodName)
        }, _toDisplayString(it.name), 9, _hoisted_5)) : _createCommentVNode("", true), it.type == 'dropdown' ? (_openBlock(), _createBlock(_component_el_dropdown, {
          key: 2,
          size: "small",
          "split-button": "",
          type: "primary",
          onClick: $event => dropbtn(it.methodName, it.name),
          onCommand: btsEmit,
          style: {
            "margin-right": "15px"
          }
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(it.dropdownlist, its => {
              return _openBlock(), _createBlock(_component_el_dropdown_item, {
                key: its.methodName,
                command: its.methodName
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(its.name), 1)]),
                _: 2
              }, 1032, ["command"]);
            }), 128))]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_createTextVNode(_toDisplayString(it.name) + " ", 1)]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]);
      }), 128)), _renderSlot(_ctx.$slots, "db")])) : _createCommentVNode("", true), dialogVisible.value ? (_openBlock(), _createBlock(_component_lcDailogzl, _mergeProps({
        key: 2,
        dialogVisible: dialogVisible.value,
        "onUpdate:dialogVisible": _cache[0] || (_cache[0] = $event => dialogVisible.value = $event),
        onHandelClose: handelClose
      }, _ctx.$attrs), null, 16, ["dialogVisible"])) : _createCommentVNode("", true), pQshow.value ? (_openBlock(), _createBlock(_component_lcDailogPQ, _mergeProps({
        key: 3,
        pQshow: pQshow.value,
        "onUpdate:pQshow": _cache[1] || (_cache[1] = $event => pQshow.value = $event),
        onHandelClose: handelClose,
        planStratTime: __props.planStratTime,
        ids: __props.ids
      }, _ctx.$attrs), null, 16, ["pQshow", "planStratTime", "ids"])) : _createCommentVNode("", true), zPshow.value ? (_openBlock(), _createBlock(_component_lcDailogZP, _mergeProps({
        key: 4,
        zPshow: zPshow.value,
        "onUpdate:zPshow": _cache[2] || (_cache[2] = $event => zPshow.value = $event),
        onHandelClose: handelClose,
        userId: __props.userId,
        ids: __props.ids
      }, _ctx.$attrs), null, 16, ["zPshow", "userId", "ids"])) : _createCommentVNode("", true), rybgshow.value ? (_openBlock(), _createBlock(_component_lcDailogrybg, _mergeProps({
        key: 5,
        rybgshow: rybgshow.value,
        "onUpdate:rybgshow": _cache[3] || (_cache[3] = $event => rybgshow.value = $event),
        onHandelClose: handelClose,
        reviewerUserId: __props.reviewerUserId,
        ids: __props.ids
      }, _ctx.$attrs), null, 16, ["rybgshow", "reviewerUserId", "ids"])) : _createCommentVNode("", true), bhshow.value ? (_openBlock(), _createBlock(_component_lcDailogrybh, _mergeProps({
        key: 6,
        bhshow: bhshow.value,
        "onUpdate:bhshow": _cache[4] || (_cache[4] = $event => bhshow.value = $event),
        onHandelClose: handelClose,
        ids: __props.ids,
        msg: __props.msg
      }, _ctx.$attrs), null, 16, ["bhshow", "ids", "msg"])) : _createCommentVNode("", true)], 64);
    };
  }
};